import { Droppable, Draggable } from "@hello-pangea/dnd";
import "./Row.scss";
import Column from "../Column/Column";
import ColumnClone from "../Column/ColumnClone";
import Section from "../customComponents/Section/Section";
import AddColumnWithField from "../dropzones/AddColumnWithField";
import { useState } from "react";
import Button from "../../../../buttons/Button";
import { buildUrl } from "../../../../utils/helper";
import Line from "../customComponents/Line/Line";

export default function Row({ props }) {
  const [isOpenedDialog, setIsOpenedDialog] = useState(false)
  if (props.row?.length === 0)
    return;
  return (
    <Draggable
      key={`row-${props.rowIndex}-grab`}
      draggableId={`row-${props.rowIndex}-grab`}
      index={props.rowIndex}
      type="row"
      isDragDisabled={isOpenedDialog}
    >
      {(providedField) => {
        if (props.row?.type === "section")
          return <Section props={{ ...props, providedField, section: props.row.data[0].data[0] }} />;
        if (props.row?.type === "line") {
          return <Line props={{ ...props, providedField, line: props.row.line }} />;
        }
        return (
          <div
            ref={providedField.innerRef}
            {...providedField.draggableProps}
            {...providedField.dragHandleProps}
            className={`row TESTING`}
          >
            <div className="rowTitle">
              <span>Riadok</span>
              <Button
                onClick={() => props.deleteRow(props.rowIndex)}
                imageUrl={buildUrl("assets/icons/close.svg")}
                title="Vymazať riadok"
                className={"row-delete"}
              />
            </div>
            <Droppable
              key={`group-${props.rowIndex}`}
              droppableId={`group-${props.rowIndex}`}
              direction="horizontal"
              type="column"
              isDropDisabled={(props.row.data.length >= 3 || props.activeMark !== 0) && props.dragStartRow !== props.rowIndex}
              renderClone={(provided, snapshot, rubric) => {
                const columnIndex = rubric.source.index;
                const columnClone = props.row.data[columnIndex];
                return (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="dnd-clone-pos"
                    style={{
                      ...provided.draggableProps.style,
                    }}
                  >
                    <ColumnClone column={columnClone} provided={provided} />
                  </div>
                );
              }}
            >
              {(providedRow, snapshotRow) => (
                <div
                  ref={providedRow.innerRef}
                  className={`group ${snapshotRow.isDraggingOver ? "dragging" : ""
                    }`}
                  {...providedRow.droppableProps}
                >
                  {props.row.data.length < 3 && props.activeMark === 0 && <AddColumnWithField {...props} rowIndex={props.rowIndex} count={0} setIsOpenedDialog={setIsOpenedDialog} />}
                  {props.row.data.map((column, columnIndex) => (
                    <Column
                      key={columnIndex}
                      uiBlocks={props.uiBlocks}
                      buildArea={props.buildArea}
                      setBuildArea={props.setBuildArea}
                      setUiBlocks={props.setUiBlocks}
                      rowIndex={props.rowIndex}
                      columnIndex={columnIndex}
                      column={column}
                      setIsOpenedDialog={setIsOpenedDialog}
                      deleteCol={props.deleteCol}
                      deleteField={props.deleteField}
                    />
                  ))}
                  {providedRow.placeholder}
                  {props.row.data.length < 3 && props.activeMark === 0 && <AddColumnWithField {...props} rowIndex={props.rowIndex} count={1} setIsOpenedDialog={setIsOpenedDialog} />}
                </div>
              )}
            </Droppable>
          </div>
        );
      }}
    </Draggable >
  );
}
